import { useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { AuthProvider } from "./provider/auth_provider";
import { detectOS } from "./utils/osDetection";
import router from "./routes/router";
import theme from "./theme";
import { useIdleTimer } from "react-idle-timer";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import "./assets/css/global.css";
import { Slide, ToastContainer } from "react-toastify";
import { decodeBase64 } from "./utils/common";

export default function App() {
  const RECAPTCHA_SITE_KEY = decodeBase64(
    process.env.REACT_APP_RECAPTCHA_SITE_KEY!,
  );

  // inactivity tracking logic
  const onIdle = () => {
    if (!["/login"].includes(window.location.pathname)) {
      localStorage.removeItem("userDetails");
      localStorage.removeItem("publicKey");
      // localStorage.removeItem("apigeeToken");
      window.location.pathname = "/login";
      alert(
        "Your session is expired because of inactivity for more than 10 minutes.",
      );
    }
  };

  const idleTimer = useIdleTimer({
    onIdle,
    timeout: 10 * 60 * 1000, // 10 mins
    throttle: 500,
  });

  useEffect(() => {
    const osClass = detectOS();
    document.body.classList.add(osClass);
  }, []);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      scriptProps={{ async: true, defer: true, appendTo: "body" }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="App">
          <SnackbarProvider>
            <AuthProvider>
              <RouterProvider router={router} />
              <ToastContainer
                position="bottom-right"
                toastStyle={{
                  minHeight: 0,
                }}
                transition={Slide}
                autoClose={3000}
                closeButton={false}
                hideProgressBar
              />
            </AuthProvider>
          </SnackbarProvider>
        </div>
      </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
}
